import logo from "../../assets/img/logo_20250311.png";
import logo2x from "../../assets/img/logo_20250311@2x.png";

const LogoHeader = ({ view="", page="normal" /*normal or advanced*/}: {title: string, page: string}) => {
    let title = "";
    if(view == "company") title = "企業様管理画面";
    else if(view == "control") title = "運営サイト";

    return (
        <div className={`hidden md:flex items-center justify-center gap-4 ${page == "advanced" ? "mb-6" : ""}`}>
            <h1 className='text-center alu-text-title font-bold leading-9 text-2xl'>
                <img src={logo}
                    srcSet={`${logo} 1x, ${logo2x} 2x`}
                    alt="aloop logo" 
                    width={page === "advanced" ? 103 : 84}
                    height={page === "advanced" ? 27 : 22}
                />
            </h1>
            {title && <h2 className={`${page == "advanced" ? "text-[1.375rem]" : "text-xs"} font-bold text-center text-black`}>{title}</h2>}
        </div>
    );
};

export default LogoHeader;